import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home/index.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login/index.vue')
  },
  {
    path: '/ai-image',
    name: 'ai-image',
    component: () => import('@/views/Ai-image/index.vue')
  },
  {
    path: '/ai-video',
    name: 'ai-video',
    component: () => import('@/views/Ai-video/index.vue')
  },
  {
    path: '/account',
    name: 'account',
    component: () => import('@/views/Account/index.vue'),
    children: [
      {
        path: '/account/api-key',
        name: 'api-key',
        component: () => import('@/views/Account/api-key.vue'),
      },
      {
        path: '/account/recharge',
        name: 'recharge',
        component: () => import('@/views/Account/recharge.vue'),
      },
      {
        path: '/account/vip-subscribe',
        name: 'vip-subscribe',
        component: () => import('@/views/Account/vip-subscribe.vue'),
      },
      {
        path: '/account/order',
        name: 'order',
        component: () => import('@/views/Account/order.vue'),
      },
      {
        path: '/account/contact-us',
        name: 'contact-us',
        component: () => import('@/views/Account/contact-us.vue')
      },
      {
        path: "/account",
        redirect: {
          path: "/account/api-key",
        },
      },
    ]
  },

  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: () => import('@/views/Account/privacy-policy.vue')
  },
  {
    path: '/terms-of-use',
    name: 'terms-of-use',
    component: () => import('@/views/Account/terms-of-use.vue')
  },
  {
    path: '/refund-policy',
    name: 'refund-policy',
    component: () => import('@/views/Account/refund-policy.vue')
  },
  {
    path: '/ai-usage-guidelines',
    name: 'ai-usage-guidelines',
    component: () => import('@/views/Account/ai-usage-guidelines.vue')
  },
  {
    path: '/minor-protection-policy',
    name: 'minor-protection-policy',
    component: () => import('@/views/Account/minor-protection-policy.vue')
  },
  {
    path: '/security-policy',
    name: 'security-policy',
    component: () => import('@/views/Account/security-policy.vue')
  },
  {
    path: '/checkoutnow',
    name: 'checkoutnow',
    component: () => import('@/views/paypal.vue')
  },
  {
    path: '/webapps/billing/subscriptions',
    name: 'subscriptions',
    component: () => import('@/views/paypal_subscriptions.vue')
  },
  // {
  //   path: '/v2/pay/:id',
  //   name: 'sunshinepe',
  //   component: () => import('@/views/sunshinepe.vue')
  // },
  {
    path: '/paymentpage/device',
    name: 'paymentTransfer',
    component: () => import('@/views/paymentTransfer.vue')
  },
  {
    path: '/:orderId',
    name: 'subscriptionTransfer',
    component: () => import('@/views/subscriptionTransfer.vue')
  },
  {
    // 路由重定向
    path: "/",
    redirect: {
      path: "/",
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // 每次路由跳转之后 新页面加载在x轴和y轴的初始位置
  scrollBehavior() {
    return {
      left: 0,
      top: 0,
    };
  },
});

// 全局前置守卫
router.beforeEach((to, from, next) => {
  next();
});

export default router
